import { Injectable } from '@angular/core';
import { DialogService } from '@sircon/sircon-ui-framework';
import { AuthenticationService } from 'src/services/authentication.service';

/**
 * How session timeout works:
 *   1 - When the user navigates to an authenticated route (see routes.js), their 'session' is reset.
 *   2 - After 45 minutes of session inactivity, a modal pops up asking them if they want to stay logged in.
 *     If yes, then their session is reset.
 *     If no, they are logged out.
 *     If they ignore, they will be automatically logged after 15 minutes.
 *   3 - Activity is defined as navigation (see #2)
 */

@Injectable({ providedIn: 'root' })
export class SessionManagementService {
    SESSION_TIMEOUT = 45 * 60 * 1000; // 45 minutes, how long before the modal prompts
    session = {};
    timeout = null;

    constructor(private dialogService: DialogService,
                private authenticationService: AuthenticationService) {}

    openTimeoutModal() {
        this.dialogService.open('session-management-dialog');
    }

    resetSession() {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }

        this.timeout = window.setTimeout(() => this.openTimeoutModal(), this.SESSION_TIMEOUT);
    }

    endSession() {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }

        this.authenticationService.timeout();
    }

}
